/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { WhseJob1402Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const whseJob1402ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  fetchIsLoading: false,
  printIsLoading: false
});

export const whseJob1402FetchWhseJob1402Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const whseJob1402FetchWhseJob1402Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const whseJob1402AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const whseJob1402RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const whseJob1402SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const whseJob1402CreateWhseJob1402Loading = (state, { boolean }) => ({
  ...state,
  createIsLoading: boolean
});

export const whseJob1402CreateWhseJob1402Success = (state, { newDocuments }) => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: [],
  newDocuments
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [WhseJob1402Types.WHSE_JOB1402_RESET_TIMESTAMP]: whseJob1402ResetTimestamp,
  [WhseJob1402Types.WHSE_JOB1402_FETCH_WHSE_JOB1402_LOADING]: whseJob1402FetchWhseJob1402Loading,
  [WhseJob1402Types.WHSE_JOB1402_FETCH_WHSE_JOB1402_SUCCESS]: whseJob1402FetchWhseJob1402Success,
  [WhseJob1402Types.WHSE_JOB1402_ADD_SELECTED_DOCUMENTS]: whseJob1402AddSelectedDocuments,
  [WhseJob1402Types.WHSE_JOB1402_REMOVE_SELECTED_DOCUMENTS]: whseJob1402RemoveSelectedDocuments,
  [WhseJob1402Types.WHSE_JOB1402_SET_WORKSPACE_VISIBLE]: whseJob1402SetWorkspaceVisible,
  [WhseJob1402Types.WHSE_JOB1402_CREATE_WHSE_JOB1402_LOADING]: whseJob1402CreateWhseJob1402Loading,
  [WhseJob1402Types.WHSE_JOB1402_CREATE_WHSE_JOB1402_SUCCESS]: whseJob1402CreateWhseJob1402Success
});
